
import { Product } from "@/models/base";
import { ProductService } from "@/services";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppProductQuickEditPrice from "./ProductQuickEditPrice.vue";

export default Vue.extend({
	data(){
		return{
			amount: 0.0,
		};
	},
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		},
	},
	computed: {
		title():TranslateResult{
			return this.$ct("edit-catalog-price");
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(value:number){
			await ProductService.setMainSupplierCatalogPrice(this.product.ID, value);
		},
		refresh(){
			this.$emit("refresh");
		}
	},
	created(){
		this.amount = this.product.BuyCatalogPrice || 0.0;
	},
	components: {
		AppProductQuickEditPrice
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
